export const createAnnouncementWithConnection = /* GraphQL */ `
  mutation CreateAnnouncement(
    $input: CreateAnnouncementInput!
    $condition: ModelAnnouncementConditionInput
  ) {
    createAnnouncement(input: $input, condition: $condition) {
      id
      tenant
      landscape
      tenantLandscape
      users {
        items {
          announcementId
          loginName
          tenant
          landscape
          tenantLandscapeLoginName
          displayStartDate
          displayEndDate
          isProcessed
          isRead
          isShow
          createdAt
          updatedAt
        }
        nextToken
      }
      title
      content
      linkToProductMenu
      isPublic
      displayStartDate
      displayEndDate
      priorityTag
      createdAt
      updatedAt
    }
  }
`;

export const updateAnnouncementWithConnection = /* GraphQL */ `
  mutation UpdateAnnouncement(
    $input: UpdateAnnouncementInput!
    $condition: ModelAnnouncementConditionInput
  ) {
    updateAnnouncement(input: $input, condition: $condition) {
      id
      tenant
      landscape
      tenantLandscape
      users {
        items {
          announcementId
          loginName
          tenant
          landscape
          tenantLandscapeLoginName
          displayStartDate
          displayEndDate
          isProcessed
          isRead
          isShow
          createdAt
          updatedAt
        }
        nextToken
      }
      title
      content
      linkToProductMenu
      isPublic
      displayStartDate
      displayEndDate
      priorityTag
      createdAt
      updatedAt
    }
  }
`;
